import { createAction, props } from "@ngrx/store";
import { TaxCountryConfig, TaxIDType } from "../../models/tax.model";

export const GetTaxIDTypes = createAction(
    '[Tax] Get Tax ID Types'
);

export const GetTaxIDTypesSuccess = createAction(
    '[Tax] Get Tax ID Types Success',
    props<{ taxIDTypes: TaxIDType[] }>()
);

export const GetTaxCountries = createAction(
    '[Tax] Get Tax Countries'
);

export const GetTaxCountriesSuccess = createAction(
    '[Tax] Get Tax Counties Success',
    props<{ countries: TaxCountryConfig[] }>()
);
